import React, { useEffect, useRef, useState } from "react";
import { Spin, Typography } from "antd";
import { googleCallback } from "../services/auth";

const { Text } = Typography;

/**
 * Handles the Google OAuth callback URL (/auth/google/callback?code=...).
 * Exchanges the code for a session via the backend, then calls onAuthComplete.
 */
const GoogleAuthCallback = ({ onAuthComplete, onError }) => {
  const [status, setStatus] = useState("Signing you in with Google…");
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const error = params.get("error");

    if (error) {
      onError?.(error === "access_denied" ? "Google sign-in was cancelled." : `Google error: ${error}`);
      return;
    }
    if (!code) {
      onError?.("No authorization code received from Google.");
      return;
    }

    setStatus("Verifying with Google…");
    googleCallback(code)
      .then((payload) => {
        setStatus("Signed in! Loading your workspace…");
        onAuthComplete?.(payload);
      })
      .catch((err) => {
        onError?.(err?.message || "Google sign-in failed. Please try again.");
      });
  }, []);

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "60vh", gap: 16 }}>
      <Spin size="large" />
      <Text type="secondary">{status}</Text>
    </div>
  );
};

export default GoogleAuthCallback;
